// modules/inicio/components/ActualizacionDisponible.js
// Banner que avisa cuando hay una versión nueva del service worker lista
// para instalarse (ver serviceWorkerRegistration.js → onUpdate, disparado
// desde index.js). El usuario decide cuándo actualizar — no se recarga
// solo, porque eso perdería datos sin guardar en un formulario abierto.

import { useEffect, useState } from "react";

export default function ActualizacionDisponible() {
  const [registro, setRegistro] = useState(null);
  const [actualizando, setActualizando] = useState(false);

  useEffect(() => {
    const onNuevaVersion = (e) => setRegistro(e.detail);
    window.addEventListener("nueva-version-disponible", onNuevaVersion);
    return () => window.removeEventListener("nueva-version-disponible", onNuevaVersion);
  }, []);

  if (!registro) return null;

  const actualizar = () => {
    setActualizando(true);
    const worker = registro.waiting;

    if (!worker) {
      window.location.reload();
      return;
    }

    // Cuando el nuevo SW termina de activarse, ahí sí se recarga — evita
    // recargar antes de tiempo y seguir viendo la versión vieja.
    worker.addEventListener("statechange", (e) => {
      if (e.target.state === "activated") window.location.reload();
    });
    worker.postMessage({ type: "SKIP_WAITING" });
  };

  return (
    <div style={{
      position: "fixed", top: 12, left: "50%", transform: "translateX(-50%)",
      background: "#1a3a5c", color: "#fff", padding: "10px 18px", borderRadius: 24,
      zIndex: 2000, display: "flex", gap: 12, alignItems: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,.3)", fontSize: "0.85rem", maxWidth: "92vw",
    }}>
      <span>🔄 Hay una nueva versión disponible</span>
      <button
        onClick={actualizar}
        disabled={actualizando}
        style={{
          background: "#fff", color: "#1a3a5c", border: "none", borderRadius: 16,
          padding: "4px 14px", fontWeight: 700, cursor: actualizando ? "default" : "pointer",
          whiteSpace: "nowrap",
        }}
      >
        {actualizando ? "Actualizando..." : "Actualizar"}
      </button>
    </div>
  );
}
